import { type CSSProperties, type ReactNode } from 'react';

import styles from './Card.module.css';

export type CardProps = {
  isTop: boolean;
  zIndex: number;
  enterSide: 'left' | 'right';
  stackTransform: string;
  innerStyle: CSSProperties;
  children?: ReactNode;
  shouldAnimate?: boolean;
  isInverted?: boolean;
};

const enterDirectionClass = (side: 'left' | 'right'): string =>
  styles[`deckEnter${side.charAt(0).toUpperCase() + side.slice(1)}`];

export const Card = ({
  isTop,
  zIndex,
  enterSide,
  stackTransform,
  innerStyle,
  children,
  shouldAnimate = true,
  isInverted = false
}: CardProps) => {
  const wrapperClasses = [
    styles.stackEnter,
    isTop && shouldAnimate && styles.deckEnter,
    isTop && shouldAnimate && enterDirectionClass(enterSide)
  ]
    .filter(Boolean)
    .join(' ');

  const cardClasses = [styles.card, styles.stackCardInner, isInverted && styles.cardInverted]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={wrapperClasses}
      style={{
        zIndex,
        pointerEvents: (isTop ? 'auto' : 'none') as CSSProperties['pointerEvents']
      }}
      aria-hidden={!isTop}
    >
      <div className={styles.stackCard} style={{ transform: stackTransform }}>
        <div className={cardClasses} style={innerStyle}>
          {children}
        </div>
      </div>
    </div>
  );
};

